import { Link } from "react-router-dom";
import { Ticket, HardHat, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const PRODUCTS = [
  {
    icon: Ticket,
    num: "01",
    name: "LANTIX",
    headline: "The social side of ticketing.",
    desc: "Social media meets ticketing. A social-first app for event discovery and tickets, where fans see what's happening, share it with friends, and get in with a tap.",
    tag: "Fan App · Ticketing & Discovery",
  },
  {
    icon: HardHat,
    num: "02",
    name: "LANTIX PRO",
    headline: "Labor and production, in cities near you.",
    desc: "A marketplace for event labor. Connecting stagehands, engineers, crew, and production companies with work in cities near you.",
    tag: "Pro App · Labor & Production",
  },
];

const Ventures = () => (
  <section id="ventures" data-testid="ventures-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <SectionHead
          eyebrow="Core Products"
          title="Two core products. One bridge between entertainment and technology."
          lead="True Life Entertainment builds software for both sides of the industry: the fans who fill rooms, and the crews who make the show happen."
        />
        <Reveal delay={0.1}>
          <Link
            to="/company"
            data-testid="ventures-company-link"
            className="inline-flex items-center gap-2 border border-line px-6 py-3 font-mono text-[11px] font-semibold uppercase tracking-[0.15em] text-charcoal-900 transition-colors hover:border-charcoal-900"
          >
            About the Company <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2">
        {PRODUCTS.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.08}>
            <div
              data-testid={`venture-card-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group flex h-full flex-col border border-line bg-white p-9 transition-colors duration-300 hover:bg-surface sm:p-10"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs font-semibold text-accent">{p.num}</span>
                <p.icon className="h-5 w-5 text-charcoal-900/40 transition-colors duration-300 group-hover:text-accent" />
              </div>
              <h3 className="mt-14 font-display text-2xl font-black tracking-tight text-charcoal-900 sm:text-3xl">{p.name}</h3>
              <p className="mt-2 font-display text-base font-bold text-accent">{p.headline}</p>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-steel">{p.desc}</p>
              <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-steel/70">{p.tag}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Ventures;
